// extracted by css-extract-rspack-plugin
export default {"collectionLink":"v9tz_"};